import { render, staticRenderFns } from "./DetalhesContratoCentralizado.vue?vue&type=template&id=424a5183"
import script from "./DetalhesContratoCentralizado.vue?vue&type=script&lang=ts"
export * from "./DetalhesContratoCentralizado.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports